export default __webpack_public_path__ + "static/media/Credit (1).ad5f4247.svg";